import { computed, ref } from 'vue'
import { useMiniStore } from '@/miniStore'
import { leaseContractOrderDetail } from '@/api/domain/orders'

export function useOrderInfoConfig(sceneKey) {
  const miniStore = useMiniStore(sceneKey)
  const baseList = [
    {
      el: 'text',
      itemConfig: {
        label: '车牌号',
        prop: 'plateNo',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '品牌',
        prop: 'brandName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车系',
        prop: 'seriesName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车型',
        prop: 'modelName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁类型',
        prop: 'rentCategoryName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '合同起止日期',
        prop: 'startDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '司机姓名',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '司机手机号',
        prop: 'tel',
      },
    },
  ]
  const orderInfoConfig = computed(() => {
    const orderDetail = miniStore.state.data.global.orderDetail || {}

    return {
      list: baseList,
      model: {
        plateNo: orderDetail.plateNo,
        modelName: orderDetail.modelName,
        brandName: orderDetail.brandName,
        seriesName: orderDetail.seriesName,
        rentCategoryName: orderDetail.rentCategoryName,
        startDate: `${orderDetail.startDate} 至 ${orderDetail.contractEndDate}`,
        customerName: orderDetail.customerName,
        tel: orderDetail.tel,
        vin: orderDetail.vin,
      },
    }
  })

  // 出库单
  const outCarInfoConfig = computed(() => {
    const orderDetail = miniStore.state.data.global.orderDetail || {}
    return {
      list: [...baseList, {
        el: 'text',
        itemConfig: {
          label: '车架号（VIN码）',
          prop: 'vin',
        },
      }],
      model: {
        plateNo: orderDetail.plateNo,
        modelName: orderDetail.modelName,
        brandName: orderDetail.brandName,
        seriesName: orderDetail.seriesName,
        rentCategoryName: orderDetail.rentCategoryName,
        startDate: `${orderDetail.startDate} 至 ${orderDetail.contractEndDate}`,
        signDate: orderDetail.startDate,
        customerName: orderDetail.customerName,
        tel: orderDetail.tel,
        vin: orderDetail.vin,
      },
    }
  })

  return { orderInfoConfig, outCarInfoConfig }
}

export function useGetOrderStepFromDetail(orderId, sceneKey, externalLoading) {
  const miniStore = useMiniStore(sceneKey)
  const loading = externalLoading || ref(false)

  // 状态与步骤的映射表
  const stateStepMapping = {
    '-1500': 0, // 选择方案
    0: 1, // 签署合同
    1000: 2, // 财务收款
    1500: 3, // 验车出库
    2500: 4, // 完成
  }

  const getAndGotoStep = async (cb) => {
    loading.value = true
    const { currentStep } = miniStore.state

    let result = null
    try {
      const { code, data } = await leaseContractOrderDetail({
        orderId,
      })
      if (code === 1) {
        result = data
        miniStore.dispatch({
          type: 'FIELD_CHANGE',
          payload: {
            stepKey: 'global',
            fieldKey: 'orderDetail',
            value: data,
          },
        })
        // 根据状态映射自动跳转到对应步骤
        const targetStep = stateStepMapping[String(data.state)]
        if (targetStep !== undefined && targetStep !== currentStep) {
          miniStore.dispatch({
            type: 'STEP_CHANGE',
            payload: { index: targetStep },
          })
        }
      }
    } finally {
      loading.value = false
      cb?.(result)
    }
  }

  return {
    getAndGotoStep,
    loading,
  }
}

export function useOrderDetail(sceneKey) {
  const miniStore = useMiniStore(sceneKey)
  const { orderId } = miniStore.state.data.global
  const queryAndSetDetail = async (outOrderId) => {
    const { code, data } = await leaseContractOrderDetail({
      orderId: outOrderId || orderId,
    })
    if (code === 1) {
      miniStore.dispatch({
        type: 'FIELD_CHANGE',
        payload: {
          stepKey: 'global',
          fieldKey: 'orderDetail',
          value: data,
        },
      })
    }
  }
  return { queryAndSetDetail }
}
